module.exports = __webpack_public_path__ + "img/img-eat-03.bd8ac2e0.png";